var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stat-card"},[_c('div',{staticClass:"stat-icon"},[_c('img',{staticClass:"stat-icon-image",attrs:{"src":_vm.getIconPath(_vm.icon),"alt":_vm.iconAlt}})]),_c('div',{staticClass:"stat-number"},[_vm._v(_vm._s(_vm.number))]),_c('div',{staticClass:"stat-desc"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }